/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Auto_Line_BreaksInputs */

const en_options_editor_auto_line_breaks = /** @type {(inputs: Options_Editor_Auto_Line_BreaksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatically Insert Line Breaks`)
};

const fr_options_editor_auto_line_breaks = /** @type {(inputs: Options_Editor_Auto_Line_BreaksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insérer automatiquement des retours à la ligne`)
};

const de_options_editor_auto_line_breaks = /** @type {(inputs: Options_Editor_Auto_Line_BreaksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Zeilenumbrüche einfügen`)
};

const it_options_editor_auto_line_breaks = /** @type {(inputs: Options_Editor_Auto_Line_BreaksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci automaticamente interruzioni di riga`)
};

const ru_options_editor_auto_line_breaks = /** @type {(inputs: Options_Editor_Auto_Line_BreaksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическая вставка переносов строк`)
};

const es_options_editor_auto_line_breaks = /** @type {(inputs: Options_Editor_Auto_Line_BreaksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar saltos de línea automáticamente`)
};

const zh_cn2_options_editor_auto_line_breaks = /** @type {(inputs: Options_Editor_Auto_Line_BreaksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动插入换行符`)
};

const ja_options_editor_auto_line_breaks = /** @type {(inputs: Options_Editor_Auto_Line_BreaksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`改行を自動的に挿入する`)
};

const hi_options_editor_auto_line_breaks = /** @type {(inputs: Options_Editor_Auto_Line_BreaksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित रूप से लाइन ब्रेक डालें`)
};

const pt_pt2_options_editor_auto_line_breaks = /** @type {(inputs: Options_Editor_Auto_Line_BreaksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir quebras de linha automaticamente`)
};

/**
* | output |
* | --- |
* | "Automatically Insert Line Breaks" |
*
* @param {Options_Editor_Auto_Line_BreaksInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_auto_line_breaks = /** @type {((inputs?: Options_Editor_Auto_Line_BreaksInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Auto_Line_BreaksInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_auto_line_breaks(inputs)
	if (locale === "de") return de_options_editor_auto_line_breaks(inputs)
	if (locale === "it") return it_options_editor_auto_line_breaks(inputs)
	if (locale === "ru") return ru_options_editor_auto_line_breaks(inputs)
	if (locale === "es") return es_options_editor_auto_line_breaks(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_auto_line_breaks(inputs)
	if (locale === "ja") return ja_options_editor_auto_line_breaks(inputs)
	if (locale === "hi") return hi_options_editor_auto_line_breaks(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_auto_line_breaks(inputs)
	return en_options_editor_auto_line_breaks(inputs)
});